import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { getLastSevenDays } from "../../../../utils/helpers";
import {
  getBoardNavigationPath,
  getValidBoards,
  isPrivateBoard,
} from "../utils/userProfileSidebarUtils";

export function useUserProfileSidebar({ profileData, userId }) {
  const navigate = useNavigate();
  const validBoards = getValidBoards(profileData);

  const handleAssignedTasksClick = useCallback(() => {
    navigate(`/my-task?tab=team&uid=${userId}`);
  }, [navigate, userId]);

  const handleWorklogsClick = useCallback(() => {
    navigate(`/my-task?tab=worklog&${getLastSevenDays()}&uid=${userId}`);
  }, [navigate, userId]);

  const handleBoardClick = useCallback(
    (board) => {
      if (isPrivateBoard(board)) {
        toast.error("Private board can't access.");
        return;
      }

      navigate(getBoardNavigationPath(board));
    },
    [navigate]
  );

  return {
    handleAssignedTasksClick,
    handleBoardClick,
    handleWorklogsClick,
    validBoards,
  };
}
